import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { TaskService } from "src/app/services/task.service";
import { TaskGroupService } from "src/app/services/taskGroup.service";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import {
    SingleSelectionFormField,
    TextFormField,
} from "src/app/shared/form/formField.model";
import nameOf from "src/app/shared/form/nameOf.helper";
import { Task } from "src/app/models/task.model";
import { Lookup } from "src/app/models/lookup.model";

export interface ITaskDialogData extends IFormDialogData {
    groupId: string;
}

@Component({
  standalone: false,
    selector: "app-task-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class TaskDialogComponent extends FormComponent<Task> implements OnInit {
    taskGroups: Lookup[] = [];
    constructor(
        dialogRef: MatDialogRef<TaskDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ITaskDialogData,
        protected taskService: TaskService,
        private taskGroupService: TaskGroupService,
        protected injector: Injector,
    ) {
        super(dialogRef, taskService, data, "Task", injector);
    }

    ngOnInit(): void {
        this.isFormLoading = true;
        forkJoin({
            entity: this.getEntity(),
            taskGroups: this.taskGroupService.getAll(),
        }).subscribe(
            (result) => {
                this.entity = result.entity;
                this.taskGroups = result.taskGroups;
                if (this.isAdd && this.data.groupId != null) {
                    this.entity.taskGroupId = this.data.groupId;
                }
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    getNewObject(): Task {
        return new Task();
    }

    validate(): boolean {
        return true;
    }

    onBeforeSave(model: Task): void {}

    closeDialog(data: Object = null) {
        this.dialogRef.close(data || true);
    }

    initFields(): void {
        this.fields = [
            new TextFormField({
                property: nameOf<Task>((x) => x.name),
                name: "Task Name",
            }),
            new SingleSelectionFormField({
                property: nameOf<Task>((x) => x.taskGroupId),
                name: "Task Group",
                options: this.taskGroups,
                required: true,
            }),
        ];
    }
}
